const state = {
    maintenance_mode_enabled: false,
    toggleMaintenanceMode: false
  };
  const getters = {
    isMaintenanceModeEnabled: state => state.maintenance_mode_enabled,
    getToggleMaintenanceMode: state => state.toggleMaintenanceMode

  };
  const actions = {
  };
  const mutations = {
    setMaintenanceModeEnabled(state, bool) {
      state.maintenance_mode_enabled = bool
    },
    setToggleMaintenanceMode(state, bool) {
        state.toggleMaintenanceMode = bool
    }
  };
  
  export default {
    state,
    getters,
    actions,
    mutations
  };